import React from "react";
import "./HouseingTransform.css";

const PantryTransform = () => {
  return (
    <section className="workplace-cta-section">
      <div className="workplace-cta-container">
        <h2 className="workplace-cta-title">
          Enhance Your Workplace Hospitality
        </h2>

        <p className="workplace-cta-text">
          Get professionally trained pantry staff to manage your office beverages
          and refreshments
        </p>

        <a
          href="https://wa.me/919899811123?text=Pantry%20Staff%20Services"
          target="_blank"
          rel="noopener noreferrer"
          className="workplace-cta-btn"
        >
          Hire Trained Pantry Staff →
        </a>
      </div>
    </section>
  );
};

export default PantryTransform;
